import React from 'react';
import { connect } from 'react-redux';
import properties from '../../../../../constants/Properties';
import availableFonts from '../../../../../constants/AvailableFonts';
import { expandFontsList } from '../../../../../actions/MenuActions';
import storeManager from '../../../../../store/StoreManager';
import platformDetection from '../../../../utils/PlatformDetection';
import { ScrollableComponent } from '../../../ScrollableComponent';
import mouseUtils from '../../../../utils/MouseUtils';
import localesManager from '../../../../../locales/LocalesManager';
import textEditorUtils from "../../utils/TextEditorUtils";

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.changeTextProperties();
    },
    onButtonClick() {
        let downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.changeTextProperties();
    },
    changeTextProperties() {
        if (this.props.executeCommand) {
            storeManager.getStore().dispatch(expandFontsList(false));

            textEditorUtils.executeAction(14, this.props.value);
            this.props.executeCommand(14, this.props.value);
            this.props.refresh();

            setTimeout(function() {
                let fontMenuButton = document.getElementById('fontsMenuButton');

                if (fontMenuButton)
                    fontMenuButton.focus();
            }.bind(this), 10);
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.shapeModel != newProps.shapeModel || this.props.isSelected != newProps.isSelected)
            return true;
        else
            return false;
    },
    render() {
        let iconColor;
        let buttonColor;

        if (this.state.isOver == true) {
            iconColor = properties.CONTEXT_HOVER_COLOR;
            buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
        } else {
            iconColor = 'black';
            buttonColor = properties.SLIDE_MENU_COLOR;
        }

        let topPosition = this.props.index * this.props.height;

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: 200,
            height: this.props.height,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: properties.BROWSER_LEFT_PADDING / 2,
            top: topPosition,
            color: 'white',
            borderStyle: 'none',
            cursor: 'pointer'
        };

        let spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 17,
            fontFamily: this.props.value,
            top: 0,
            pointerEvents: 'none'
        };

        let iconVisible;

        if (this.props.isSelected)
            iconVisible = 'block';
        else
            iconVisible = 'none';

        const iconStyle = {
            position: 'absolute',
            top: 11,
            right: 14,
            color: iconColor,
            display: iconVisible,
            pointerEvents: 'none'
        };

        if (platformDetection.isIOS() == true) {
            spanStyle.fontSize = 18;
        }

        return (
            <button ref="button" aria-label={this.props.value} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onButtonClick} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp}>
                <span style={spanStyle}>{this.props.value}</span>
                <i style={iconStyle} className='fa fa-check'></i>
            </button>
        );
    }
});

export const FontMenuContent = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onExpand (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const isExpanded = !this.props.fontsListIsExpanded;
        this.props.dispatch(expandFontsList(isExpanded));
    },
    onListChanged (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        setTimeout(this.refreshView, 6);
    },
    refreshView() {
        setTimeout(function () {
            this.forceUpdate();
        }.bind(this), 5);
    },
    getFontsDataProvider () {
        return availableFonts.getAvailableFonts();
    },
    getCurrentFontTopPosition(currentFont) {
        let top = 6;

        switch(currentFont) {
            case 'BungeeShade': {
                if (platformDetection.isChromeBook())
                    top = 1;
                else
                    top = -6;
                break;
            }

            case 'Sriracha': {
                top = 1;
                break;
            }

            case 'ArchitectsDaughter':
            case 'Anton':
            case 'PermanentMarker': {
                top = 4;
                break;
            }

            case 'Cabin':
            case 'CabinMedium': {
                top = 6;
                break;
            }

            case 'Arial':
            case 'Creepster': {
                top = 7;
                break;
            }

            case 'AlfaSlabOne': {
                top = 5;
                break;
            }
            case 'Bangers': {
                top = 8;
                break;
            }
        }

        return top;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.fontsListIsExpanded != newProps.fontsListIsExpanded || this.props.contextTarget != newProps.contextTarget || this.props.fontName != newProps.fontName)
            return true;
        else
            return false;
    },
    render() {
        const currentFontFamily = this.props.fontName;
        let height = this.props.buttonSize;
        let menuWidth = this.props.width;
        let buttonHeight = this.props.buttonSize;
        let borderWidth = 2;
        let visibleItems = 16;

        if (this.props.fontsListIsExpanded == true)
            height = height + visibleItems * buttonHeight + 2 * borderWidth;

        let fontsStyle = {
            position: 'absolute',
            top: this.props.top > 0 ? this.props.top : 0,
            left: 0,
            width: menuWidth + 2 * borderWidth,
            height: height,
            overflowY: 'hidden',
            backgroundColor: 'white',
            zIndex: 1000,
            display: 'table',
            cursor: 'pointer'
        };

        let borderColor;
        let textColor;

        if (this.state.isOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            textColor = borderColor;
        } else {
            borderColor = '#e7e7e7';
            textColor = 'black';
        }

        const fontsButtonStyle = {
            width: menuWidth - 2 * borderWidth,
            height: buttonHeight - 2 * borderWidth,
            background: 'white',
            borderRadius: 5,
            position: 'absolute',
            left: 0,
            top: 0,
            borderColor: borderColor,
            borderWidth: borderWidth,
            borderStyle: 'solid',
            alignItems: 'center',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            textAlign: 'left',
            cursor: 'pointer'
        };

        let icon;

        if (this.props.fontsListIsExpanded == true)
            icon = 'fa fa-angle-down';
        else
            icon = 'fa fa-angle-right';

        const fontsIconStyle = {
            position: 'absolute',
            top: 7,
            right: 7,
            color: textColor,
            pointerEvents: 'none'
        };

        let spanStyle = {
            position: 'absolute',
            color: textColor,
            cursor: 'default',
            fontSize: 15,
            top: this.getCurrentFontTopPosition(currentFontFamily),
            paddingLeft: 5,
            fontFamily: currentFontFamily,
            pointerEvents: 'none'
        };

        let elements = [];
        let listDisplay;
        let dataProvider;

        if (this.props.fontsListIsExpanded == true) {
            dataProvider = this.getFontsDataProvider();


            for (let i=0; i<dataProvider.length; i++) {
                let isSelected = false;

                if (currentFontFamily == dataProvider[i])
                    isSelected = true;

                elements.push(<Button executeCommand={this.props.executeCommand} refresh={this.refreshView} height={buttonHeight} accordionWidth={menuWidth} index={i} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget} key={'font' + dataProvider[i]} value={dataProvider[i]} isSelected={isSelected}/>);
            }

            listDisplay = 'block';
        }   else {
            listDisplay = 'none';
        }

        const fontsListStyle = {
            position: 'absolute',
            width: 6 * this.props.buttonSize,
            height: buttonHeight * visibleItems,
            top: buttonHeight + 2,
            left: 0,
            borderColor: properties.EFFECTS_BUTTON_BORDER_COLOR,
            borderWidth: 1,
            borderStyle: 'solid',
            display: listDisplay,
            overflowY: 'hidden',
            overflowX: 'hidden'
        };

        let componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = fontsListStyle.width;
        componentProperties.height = fontsListStyle.height;
        componentProperties.scrollHeight = dataProvider != undefined ? dataProvider.length * buttonHeight : 0;
        componentProperties.top = 0;
        componentProperties.displayState = 'block';
        componentProperties.elements = elements;

        return (
            <div id='fontsMenu' style={fontsStyle}>
                <button id='fontsMenuButton' aria-label={localesManager.getCaption('fontSelector', 'other')} style={fontsButtonStyle} onTouchEnd={this.onExpand} onClick={this.onExpand} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                    <span style={spanStyle}>{currentFontFamily}</span>
                    <i style={fontsIconStyle} className={icon}></i>
                </button>
                <div style={fontsListStyle} onTouchEnd={this.onListChanged} onClick={this.onListChanged}>
                    <ScrollableComponent componentProperties={componentProperties}/>
                </div>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const fontsListIsExpanded = state.menu.fontsListIsExpanded;

    return {
        fontsListIsExpanded
    };
}

export const FontMenu = connect(mapStateToProps)(FontMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/subcomponents/FontMenu.js
 **/